
<div class="side-appbar" [ngClass]="{ 'side-appbar-open' : showsidebar, 'filter-card-size' : isFilterCard }" data-simplebar>
    
  <div (click)= "closepanel()"  class="side-appbar-close" ><img src="assets/ph-bhp-layout/svg/remove.svg">
  </div>
  <div class="container-fluid">
    <ng-content ></ng-content>
  </div>
</div>

<div id="page_overlay" *ngIf="showsidebar"></div>

